import Connections from '../../connections';
import {
  action,
} from 'mobx';
import {
  forgotPasswordEmail,
} from '../../axios/requests';
import {
  IForgotPasswordStore,
} from '../storeInterfaces/forgotPasswordInterface';

export class ForgotPasswordStore implements IForgotPasswordStore {
  @action
  public async handleForgotPasswordEmail(email: string): Promise<any> {
    try {
      const data = {
        email,
      };
      const response = await Connections.wadiDeglaAxios.httpPost(forgotPasswordEmail, data);
    } catch (error) {
      console.log(error);
    }
  }
}
